module.exports = __webpack_public_path__ + "05_long_gold.d648dc42.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/05_long_gold.png
// module id = uIkE
// module chunks = 0